import React, { useState, useEffect } from 'react';
import { LookupItem } from '../models/lookup-item';
import { EnumerationTypeTable } from '../models/enumeration-type-table';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import DataGrid, {
    Column,
    SearchPanel,
    Selection,
    Toolbar,
    Paging,
    Item as ToolBarItem,
    LoadPanel
} from 'devextreme-react/data-grid';

import { TextBox } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { CrudFunctions } from '../utilities/crud-functions';

//this form needs severe work - I just updated it to get rid of old patterns and objects

export default function EnumerationsForm() {
    const [enumerationTypeTables, setEnumerationTypeTables] =
        useState<EnumerationTypeTable[]>();

    const [selectedEnumerationTypeTable, setSelectedEnumerationTypeTable] =
        useState<EnumerationTypeTable>();

    const [newValue, setNewValue] =
        useState<string>();

    const [updateValue, setUpdateValue] =
        useState<string>();

    const [description, setDescription] =
        useState<string>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    return (
        <div>
            <div className="lq-title-bar">
                <div className="lq-main-title">Enumeration Values</div>
            </div>

            <div id="enum-main">
                <div id="enum-lookupTables">
                    <DataGrid
                        height="100%"
                        onSelectionChanged={enumerationTypeTableSelectionChanged}
                        dataSource={enumerationTypeTables ?
                            enumerationTypeTables : []}
                        showBorders={true}>

                        <LoadPanel enabled={true} />
                        <Selection mode={'single'} />
                        <SearchPanel visible={true} />
                        <Paging enabled={false} />

                        <Column dataField={'name'} />

                        <Toolbar>
                            <ToolBarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">Enumerations</div>
                                </div>
                            </ToolBarItem>
                        </Toolbar>

                    </DataGrid>

                </div>

                <div id="enum-lookupValues">
                    <DataGrid
                        height="100%"
                        dataSource={selectedEnumerationTypeTable && selectedEnumerationTypeTable.values ?
                            selectedEnumerationTypeTable.values : []}
                        showBorders={true}>

                        <LoadPanel enabled={true} />
                        <Selection mode={'single'} />
                        <Paging enabled={false} />

                        <Column dataField={'id'} caption="ID" width={'10%'} />
                        <Column dataField={'name'} width={'30%'} />
                        <Column dataField={'description'} width={'60%'} />

                        <Toolbar>
                            <ToolBarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">Enumeration Tables</div>
                                </div>
                            </ToolBarItem>
                        </Toolbar>

                    </DataGrid>
                </div>

                <div id="enum-editing">
                    <div className="stack-box">

                        <div className="enum-text-button">
                            <div className="form-unit">
                                <label className="textbox-label">Add Value</label>
                                <TextBox id="txtAddValue" className="textbox"
                                    onValueChanged={addValueChanged}
                                    placeholder="add value" value={newValue ? newValue : undefined} />
                            </div>

                            <div className="enum-button">
                                <Button id="addButton" text="Add" height={'2.5em'} width={'6em'}
                                    type="normal" onClick={onAddValue} />
                            </div>
                        </div>

                        <div className="enum-text-button">
                            <div className="form-unit">
                                <label className="textbox-label">Update Value</label>
                                <TextBox id="txtUpdateValue" className="textbox"
                                    onValueChanged={updateValueChanged}
                                    placeholder="update value" value={updateValue ? updateValue : undefined} />
                            </div>

                            <div className="enum-button">
                                <Button id="updateButton" text="Update" height={'2.5em'} width={'6em'}
                                    type="normal" onClick={onUpdateValue} />
                            </div>
                        </div>

                        <div className="enum-text-button">
                            <div className="form-unit">
                                <label className="textbox-label">Update Description</label>
                                <TextBox id="txtUpdateDescription" className="textbox"
                                    onValueChanged={updateDescriptionChanged}
                                    placeholder="update description" value={description} />
                            </div>

                            <div className="enum-button">
                                <Button id="updateButton" text="Update" height={'2.5em'} width={'6em'}
                                    type="normal" onClick={onUpdateDescription} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function onAddValue() {

    }


    function onUpdateValue() {

    }

    function onUpdateDescription() {

    }


    function enumerationTypeTableSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedEnumerationTypeTable(e.selectedRowsData[0]);
    }

    function addValueChanged(e: any) {
        setNewValue(e.value);
    }

    function updateValueChanged(e: any) {
        setUpdateValue(e.value);
    }

    function updateDescriptionChanged(e: any) {
        setDescription(e.value);
    }


    async function getAllData() {
        await getLookupTables();
    }

    async function getLookupTables() {

        await CrudFunctions.getData("common/enumerationTypes")
            .then((data) => {
                setEnumerationTypeTables(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Enumeration Types");
            });
    }

    //render

    function enumerationsToolbarTitleTemplateRender(e: any) {
        return (
            <div className="pw-datagrid-toolbar-template">
                <div className="pw-datagrid-toobar-title">Lookup Tables</div>
            </div>
        );
    }

    function enumerationToolbarTitleTemplateRender(e: any) {
        return (
            <div className="pw-datagrid-toolbar-template">
                <div className="pw-datagrid-toobar-title">Values</div>
            </div>
        );
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}



